const actions = {
    selectAticle(context, data) {
      data === '' ? (context.articleList = null) : (context.articleList = data)
      context.commit('selectAticle',data)
    }
  }
  
  export default actions


// WEBPACK FOOTER //
// ./src/store/actions.js